import Color from "./Color";

export enum Alignment {
  LEFT = "0",
  CENTER = "1",
  RIGHT = "2",
}

export default class FontArray {
  //"Alignment:0|Color:FFFFFF|Name:HelveticaNeue-CondensedBold|Size:90.000000|Range:{0, 10}"
  alignment: Alignment | null;
  color: Color | null;
  name: string;
  size: number;
  range: [number, number];
  __typeFace: string;
  __typeStyle: string;

  constructor(
      alignment: Alignment | null,
      color: Color | null,
      name: string,
      size: number,
      range: [number, number],
      __typeFace: string,
      __typeStyle: string,
    ) {
    this.alignment = alignment;
    this.color = color;
    this.name = name;
    this.size = size;
    this.range = range;
    this.__typeFace = __typeFace;
    this.__typeStyle = __typeStyle;
  }

  updateRange(length: number): void {
    this.range = [this.range[0], length];
  }

  toFontArray(): string {
    //"Alignment:0|Color:FFFFFF|Name:HelveticaNeue-CondensedBold|Size:90.000000|Range:{0, 10}"
    if (!this.alignment && !this.color) {
      return `Name:${this.name}|Size:${this.size.toFixed(6)}|Range:{${
        this.range[0]
      }, ${this.range[1]}}`;
    } else {
      return `Alignment:${this.alignment}|Color:${this.color!.asIOS()}|Name:${
        this.name
      }|Size:${this.size.toFixed(6)}|Range:{${this.range[0]}, ${
        this.range[1]
      }}`;
    }
  }

  static fromJSON(json: any): FontArray {
    const val = FontArray.fromString(json);
    return val;
  }

  toJSON(): any {
    // copy all fields from `this` to an empty object and return in
    return this.toFontArray();
  }

  equals(other: FontArray): boolean {
    return (
      this.alignment === other.alignment &&
      this.color === other.color &&
      this.name === other.name &&
      this.range === other.range &&
      this.size === other.size
    );
  }

  equalsIgnoringRange(other: FontArray): boolean {
    return (
      this.alignment === other.alignment &&
      (this.color?.equals(other.color) || false) &&
      this.name === other.name &&
      this.size === other.size
    );
  }

  setTypeFace(typeF: string) {
    this.__typeFace = typeF;
    const [_, style] = this.name.split("-");
    this.name = `${typeF}-${style}`;
  }

  setTypeStyle(typeS: string) {
    this.__typeStyle = typeS;
    const [face, _] = this.name.split("-");
    this.name = `${face}-${typeS}`;
  }

  static fromString(
    val: string | string[]
    ): FontArray {
    const value = Array.isArray(val) ? val[0] : val;
    const pieces = value.split("|");
    if (pieces.length > 3) {
      let alignment = null;
      switch (Number(pieces[0].split(":")[1])) {
        case 0:
          alignment = Alignment.LEFT;
          break;
        case 1:
          alignment = Alignment.CENTER;
          break;
        case 2:
          alignment = Alignment.RIGHT;
          break;
      }
      const color = Color.iosToCssColor(pieces[1].split(":")[1]);
      const name = pieces[2].split(":")[1];
      const splitName = name.split("-");
      const __typeFace = splitName[0];
      const __typeStyle = splitName[1] || "";
      const size = Number(pieces[3].split(":")[1]);
      const ranges = pieces[4].split(":")[1].split(",");
      const range: [number,number] = [
        Number(ranges[0].replace("{", "")),
        Number(ranges[1].replace("}", "")),
      ];
      return new FontArray(alignment, color, name, size, range, __typeFace,__typeStyle);
    }
    const alignment = null;
    const color = null;
    const name = pieces[0].split(":")[1];
    const splitName = name.split("-");
    const __typeFace = splitName[0];
    const __typeStyle = splitName[1] || "";
    const size = Number(pieces[1].split(":")[1]);
    const ranges = pieces[2].split(":")[1].split(",");
    const range: [number,number] = [
      Number(ranges[0].replace("{", "")),
      Number(ranges[1].replace("}", "")),
    ];
    return new FontArray(alignment, color, name, size, range, __typeFace,__typeStyle);
  }
}

FontArray.displayName = "FontArray";
